import * as actions from './editor.action';
import inicialState from './editor.state';

const editorComponentReducer = (state = inicialState, action) => {
  switch (action.type) {

    case actions.EDITOR_COMPONENT_INICIALIZADO:
      return {
        ...state,
        editorInicializado: action.payload.editorInicializado,
      };
    case actions.EDITOR_COMPONENT_ALTURA:
      return {
        ...state,
        alturaEditor: action.payload.alturaEditor,
      };
    case actions.EDITOR_COMPONENT_LARGURA:
      return {
        ...state,
        larguraEditor: action.payload.larguraEditor,
      };
    case actions.EDITOR_COMPONENT_CARREGADO:
      return {
          ...state,
          editorCarregado: action.payload.editorCarregado,
      };
    case actions.EDITOR_COMPONENT_TEXTO_INICIAL:
      return {
          ...state,
          textoInicial: action.payload.textoInicial,
      };
    case actions.EDITOR_COMPONENT_AUTOSAVE:
        return {
            ...state,
            autoSaveEditor: action.payload.autoSaveEditor,
        };
    case actions.EDITOR_COMPONENT_SHOW_EDITOR:
        return {
            ...state,
            showEditor: action.payload.showEditor,
        };
    //OLD
    case actions.DADOS_EDITOR_COMPONENT_RTF:
      return {
        ...state,
        textRtf: action.payload.textRtf,
      };
    case actions.DADOS_EDITOR_COMPONENT_PLAIN_TEXT:
      return {
        ...state,
        plainText: action.payload.plainText,
      };

    case actions.ID_RTF_EDITOR_COMPONENT:
      return {
        ...state,
        idRtf: action.payload.idRtf,
      };

    case actions.EDITOR_COMPONENT_READONLY:
      return {
        ...state,
        editorReadOnly: action.payload.editorReadOnly,
      };

    case actions.EDITOR_COMPONENT_CHANGE_STATUS:
      return {
        ...state,
        status: action.payload.status,
      };

    case actions.EDITOR_COMPONENT_ATUALIZAR_AVISO:
      return {
        ...state,
        mensagem: action.payload.mensagem,
        tipo: action.payload.tipo,
      };

    default:
      return state;
  }
};

export default editorComponentReducer;



// WEBPACK FOOTER //
// ./src/componentes/editor/editor.reducer.js